<template>
  <v-container class="mt-0 pt-0 pl-0 ptoContainer">
    <v-row v-if="can_delegate == true" class="mt-0 pt-0">
      <v-col class="mt-0 pt-0">
        <v-form ref="delegate_form" v-model="valid"  lazy-validation>
          <v-checkbox
            v-model="input.delegate"
            :label="`Share access to manage your team's PTO requests.`"
            :disabled="shared_delegate == true"
            class="font-weight-bold"
            @change="showHideFields('delegate')"
          ></v-checkbox>
          <v-container v-if="form_visible">

        <v-alert class="mb-10 ml-n3" v-if="shared_delegate == true"
          border="bottom"
          colored-border
          type="error"
          color="#ffb500"
          elevation="3"
        >
            {{ alert_msg }}
            <div class="italic">To end delegated access, select "Do not share" from dropdown menu and save your changes.</div> 

        </v-alert>              
<!--
            <v-layout row wrap>
              <v-flex xs12 md3 class="font-weight-bold"
                >Delegated Access</v-flex
              >
              <v-flex xs12 md9
                > 
                  <v-select
              v-model="input.delegate_id"
              label="Not Shared"
              :items="delegate_list"
              item-value="id"
              item-text="name"
              aria-label="Delegated Access"
              class="messages black--text"
              outlined
              single-line
              dense
              @change="showHideFields('delegate_id')"
            />
                <div class="font-weight-light italic">
                  In addition to yourself, the user above is able to approve or deny pending PTO requests
                  for your team on your behalf. You may change your selection at
                  any time.
                </div>
              </v-flex>
            </v-layout>
-->

           <v-layout row wrap>
              <v-flex xs12 md3 class="font-weight-bold"
                >Delegated Access</v-flex
              >
              <v-flex xs12 md9
                > 
                  <v-autocomplete
                    v-model="input.delegate_auid"
                    :items="delegate_list2"
                    :search-input.sync="search"
                    item-value="id"
                    item-text="name"
                    :filter="searchFilter"
                    :maxlength="30"
                    no-data-text="No matching found"
                    outlined
                    clearable
                    flat
                    placeholder="Enter Delegate Name"
                    aria-label="Delegated Access"
                    class="messages black--text"
                    single-line
                    dense
                    @change="showHideFields('delegate_auid')"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title>
                            <span v-if="dropdown_msg == 'empty'">No matching found. </span>
                            <span v-else-if="dropdown_msg == 'exceed_three_words'">Please enter first name and/or last name. Do not enter more than three words.</span>
                            <span v-else>Enter Delegate Name</span>
                        </v-list-item-title>
                      </v-list-item>
                    </template>                             
                  </v-autocomplete>
                <div class="font-weight-light italic">
                  <ul>
                  <li>To add or change your selection type your delegate's name in the open field above. The name should start to pre-populate. Select your preferred delegate and submit changes. </li>
                  <li>In addition to yourself, the user above is able to approve or deny pending PTO requests
                  for your team on your behalf. You may change your selection at
                  any time.</li>
                  </ul>
                </div>
              </v-flex>
            </v-layout>

            <v-layout row wrap  v-if="form_fields_visible">
              <v-flex xs12 md3 class="font-weight-bold">Access Duration</v-flex>
              <v-flex xs12 md9>
                <v-radio-group v-model="input.indefinite" mandatory >
                  <v-radio
                    label="Schedule duration"
                    value="0"
                    class="black--text"
                    @change="showHideFields('indefinite_0')"
                  ></v-radio>
                  <v-radio
                    label="Indefinite access"
                    value="1"
                    class="black--text"
                    @change="showHideFields('indefinite_1')"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>

            <v-layout row wrap v-if="form_fields_visible">
              <v-flex xs12 md3 class="font-weight-bold">Start Date</v-flex>
              <v-flex xs12 md9>
                <v-menu
                  v-model="start_menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="input.start_date"
                      aria-label="Select Start Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      single-line
                      dense
                      required
                      :rules="startDateRules"
                      class="messages"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="input.start_date"
                    no-title
                    color="#4f2c1d"
                    class="dt-picker"
                    :min="new Date().toISOString().substr(0, 10)"
                    @input="
                      start_menu = false;
                      !!input.end_date ? (input.end_date = input.end_date) : (input.end_date = input.start_date);
                    "
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>

            <v-layout row wrap v-if="form_fields_visible && form_end_date_visible">
              <v-flex xs12 md3 class="font-weight-bold">End Date </v-flex>
              <v-flex xs12 md9>
                <v-menu
                  v-model="end_menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="input.end_date"
                      aria-label="Select End Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      single-line
                      dense
                      required
                      class="messages"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="input.end_date"
                    no-title
                    color="#4f2c1d"
                    class="dt-picker"
                    @input="end_menu = false"
                    required
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>

            <v-btn class="ma-2" color="#FFB500" :disabled="!valid" depressed @click="submitDelegate">
          Submit Changes</v-btn>

          </v-container>
        </v-form>
      </v-col>
    </v-row>

    <div class="text-center">
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            {{ dialog_title }}
          </v-card-title>
          <v-card-text>{{ dialog_text }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog(dialog_type)">
              {{ dialog_ok }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

  </v-container>
</template>


<script>
import axios from 'axios';
import pto_func from "@/pto_functions";

export default {
  data: () => ({
    can_delegate: false,
    shared_delegate: false,
    delegate_name: "",
    delegate_name_long: "",
    //who_delegated: "",
    is_trainer: false,
    dropdown_msg: "", 
    alert_msg: "",

    start_menu: "",
    end_menu: "",
    // one level up and everyone in the same job dept
    delegate_saas_list: [],
    delegate_list: [{"id": "stop", "name": "Do not share"}],
    delegate_list2: [],
    saas_data: null,

    form_visible: false,
    form_fields_visible: false,
    form_end_date_visible: false,

    input: {
      delegate: null,
      delegate_id: null,
      delegate_auid: null,
      indefinite: 0,
      start_date: null,
      end_date: null,
    },

    disabledDates: {
      to: new Date(Date.now() - 8640000)
    },

    valid: true,
    startDateRules: [(v) => !!v || "Start Date is required"],

    dialog: false,
    dialog_title: "Alert!",
    dialog_ok: "OK",
    dialog_text: "",
    dialog_type: "",

    loading: false,
    items: [],
    search: null,
    select: null,
    previous_search: "",
  }),

  created() {
    /*
    axios.get("./remote-apis/pto_api.php?cmd=pto_trainer").then((response) => {
      if (response.data == null) {
          this.is_trainer = false;
          return;
      } else {
        this.is_trainer = response.data.is_trainer; 
        window.console.log("is trainer 1: " + this.is_trainer);
      }
    }); */

    axios.get('./remote-apis/pto_api.php?cmd=pto_delegate')
      .then(response => {                
        if (response.data == null) {
          this.can_delegate = false;
          return;
        }else {
          this.can_delegate = true;
          this.saas_data = response.data;
          //window.console.log("saas name: " + this.saas_data['delegate_name']);

          this.input.delegate_id = this.saas_data['delegate'];
          this.input.delegate_auid = this.saas_data['delegate'];
          this.is_trainer = this.saas_data['is_trainer'];
          if (this.is_trainer == true) {
            this.delegate_name = pto_func.maskEmpName(this.saas_data['delegate_name']);
            this.delegate_name_long = this.delegate_name;
          } else {
            this.delegate_name = this.saas_data['delegate_name'];
            this.delegate_name_long = this.delegate_name;
          }
          this.input.indefinite = this.saas_data['indefinite'];
          this.input.start_date = this.saas_data['start_date'];
          this.input.end_date = this.saas_data['end_date'];
          this.delegate_saas_list = this.saas_data['delegate_list'];

          var today = pto_func.get_today_date();
          // shared access expired?
          if (this.saas_data['start_date'] && this.saas_data['end_date'] &&
            (!this.saas_data['indefinite'] || this.saas_data['indefinite'] == "0")) {
            var e_date = new Date(pto_func.formatSaasDate(this.input.end_date) + "T09:00:00.000Z");
            // when shared access expired, saas still return value, clear expired data.
            if (e_date.getTime() < today.getTime()) {
              this.input.delegate_id = null;
              this.input.delegate_auid = null;
              this.delegate_name = "";
              this.delegate_name_long = "";
              this.input.indefinite = 0;
              this.input.start_date = null;
              this.input.end_date = null;
            }
          }

          // "stop" or 7 digit au id  
          if (!this.input.delegate_id)
            this.input.delegate_id = "stop";

          //if (!this.input.delegate_auid)
          //  this.input.delegate_auid = "stop";

          if (this.input.start_date) 
            this.input.start_date = pto_func.formatSaasDate(this.input.start_date);

          if (this.input.end_date) 
            this.input.end_date = pto_func.formatSaasDate(this.input.end_date);

          if ((this.input.delegate_id != null && this.input.delegate_id.length > 4) || 
              (this.input.delegate_auid != null && this.input.delegate_auid.length > 4)) {
            this.form_visible = true;
            this.form_fields_visible = true;
            this.input.delegate = true;
            this.shared_delegate = true;
          }

          if (!this.input.indefinite || this.input.indefinite == 0 || this.input.indefinite == "0")
            this.form_end_date_visible = true;

          let delegate_name = "";

          for (let i = 0; i < this.delegate_saas_list.length; i++) {
            if (this.delegate_saas_list[i]['id'].length <= 0)
              continue;

            if (this.delegate_saas_list[i]['name'].length <= 0) {
              delegate_name = "---";
            } else {
              //delegate_name = pto_func.maskEmpName(this.delegate_saas_list[i]['name']);
              delegate_name = this.delegate_saas_list[i]['name'];
            }

            if (this.is_trainer == true) {
              this.delegate_list.push({ 
                "id": this.delegate_saas_list[i]['id'], 
                "name": pto_func.maskEmpName(delegate_name)
              });
            } else {
              this.delegate_list.push({ 
                "id": this.delegate_saas_list[i]['id'], 
                "name": delegate_name
              });
            }
          }

          // delegate_list2
          if (this.input.delegate_auid) {
            // format delegate_name_long with dept name
            this.queryDelegateInfo(this.input.delegate_auid);
            this.delegate_list2.push({ 
                "id": "stop", 
                "name": "Do not share"
              });
              this.delegate_list2.push({ 
                "id": this.input.delegate_auid, 
                "name": this.delegate_name_long
              });
          }

          // alert message 
          if (this.input.indefinite == '0')
            this.alert_msg = (this.is_trainer == true ? pto_func.maskEmpName(this.delegate_name) : this.delegate_name ) + " has delegated access from " + this.input.start_date + " to " + this.input.end_date + ". " ;
          else
            this.alert_msg = (this.is_trainer == true ? pto_func.maskEmpName(this.delegate_name) : this.delegate_name )  + " has indefinite access starting " + this.input.start_date + ". " ;

        }
      })
      /*
      axios.get("./remote-apis/pto_api.php?cmd=pto_delegate_access").then((response) => {
        //this.dg = response.data;
        this.who_delegated = response.data.who_delegated;  
      }); */
      
  },

  mounted() {},

  computed: {},

  watch: {
    search (val) {
      //window.console.log("search: " + val + " auid = " + this.input.delegate_auid );
      if (!val) {
        this.input.delegate_auid = "";
        this.dropdown_msg = "";          
        //window.console.log("stop @ no val....");
        return;
      } else if (val.toUpperCase() == "DO NOT SHARE") {
        //window.console.log("stop @ do not share....");
        return;
      } else if (val == this.previous_search) {
        //window.console.log("stop @ same search....");
        return;
      }

      val && val !== this.previous_search && this.querySelections(val) 
      this.previous_search = val;
      //window.console.log("prev = " + this.previous_search);
/*** 
      //val && val !== this.input.delegate_auid && this.querySelections(val) 
      //if (this.delegate_list2.length > 0) return
      window.console.log("loading? " + this.loading);
      // Items have already been requested
      if (this.loading) return;
      this.querySelections(val)    
***/
    },
  },  

  methods: {

    searchFilter (item, queryText) {  
      // filter each option to match search text
      const nameText = item.name.toLowerCase();   // looping name in delegate_list2
      const searchText = queryText.toLowerCase().trim(); // from input field
      const notShareText = "do not share";        // include Do Not Share in dropdown
      return nameText.indexOf(searchText) > -1 ||
          nameText.indexOf(notShareText) > -1
    },

    querySelections (v) {
      this.loading = true;
      //window.console.log("in querySelections() .... " + v + ", loading: " + this.loading);

      this.delegate_list2 = [];
      
       axios
          .post("./remote-apis/pto_api.php?cmd=pto_delegate_search", {
            formData: JSON.stringify(this.input),
            searched: JSON.stringify(v),
          })
          .then((res) => {            
            if (!res.data.error) {
              this.delegate_list2 = res.data.delegate_list;
            } else {
              this.delegate_list2 = [];
              if (res.data.error == "exceed_three_words") {
                this.dropdown_msg = "exceed_three_words";
              }
            } 
            if (this.delegate_list2.length <= 0 && !res.data.error) 
              this.dropdown_msg = "empty";        
          })
          .catch((error) => {
            window.console.log(error);
          });               
      /*
      setTimeout(() => {        
        this.delegate_list2 = this.states.filter(e => {
          return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
        })
        this.loading = false
      }, 500) */
       this.loading = false;
       return;
    },    


    queryDelegateInfo (auid) {
      // db search delegate name by ID
      axios
        .post("./remote-apis/pto_api.php?cmd=pto_delegate_info", {
            auid: JSON.stringify(auid),
          })
          .then((res) => { 
            this.delegate_name = res.data.name;
            this.delegate_name_long = res.data.name_long;
          })
          .catch((error) => {
            window.console.log(error);
          });     

       return;   

    },

    showHideFields(type) {
      switch (type) {
         case "delegate": // the checkbox on top
            if (this.input.delegate == true)
              this.form_visible = true;
            else
              this.form_visible = false;
            break;
         case "delegate_id": // old dropdown menu
            //window.console.log(this.input.delegate_id.length);
            if (this.input.delegate_id && this.input.delegate_id.length > 4) {
              this.form_fields_visible = true;
            } else {
              this.form_fields_visible = false;
            }

            if (this.input.indefinite != null && (this.input.indefinite == 1 || this.input.indefinite == "1")) {
              this.form_end_date_visible = false;
            } else {
              this.form_end_date_visible = true;
            }
            break;
         case "delegate_auid": // dropdown menu
            if (this.input.delegate_auid && this.input.delegate_auid == "stop") {
              this.form_fields_visible = false;
            } else {
              this.form_fields_visible = true;
            }

            this.resetDelegateForm(type);

            if (this.input.indefinite != null && (this.input.indefinite == 1 || this.input.indefinite == "1")) {
              this.form_end_date_visible = false;
            } else {
              this.form_end_date_visible = true;
            } 
            return;
        case "indefinite_1":  // duration      
        case "indefinite_0":  // duration      
            var tmp = type.split("_");
            var indefinite = tmp[1];
            if (indefinite != null && (indefinite == 1 || indefinite == "1")) {
              this.form_end_date_visible = false;
            } else {
              this.form_end_date_visible = true;
            }
            break;
      }

      this.resetDelegateForm(type);

    },


    resetDelegateForm(type) {

      if (type == "delegate")  {
        this.input.delegate_id = "stop";
        this.input.delegate_auid = null;
      }

      if (type == "delegate" || type == "delegate_id" || type == "delegate_auid")
        this.input.indefinite = 0;

      //if (type == "indefinite_1") {
        var today = new Date()
            .toLocaleString("en-us", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            timeZone: "UTC"
          })
          .replace(/(\d+)\/(\d+)\/(\d+)/, "$3-$1-$2");
        this.input.start_date = today;  
      //} else {  window.console.log("Reset start date?????       type = " + type );
      //  this.input.start_date = null;
      //}
        
      this.input.end_date = null;

      return;

    },


    submitDelegate() {

      if (this.hasSubmitError())
        return false;
       axios
          .post("./remote-apis/ptoApprove.php", {
            formData: JSON.stringify(this.input),
            action: JSON.stringify("delegate"),
          })
          .then((res) => {
            if (res.data.response == "OK") {
              this.dialog_title = "Thank you!";
              this.dialog_text =
                "Data has been saved.";
              this.dialog_type = "success";
              this.dialog = true;
            } else if (res.data.response == "FAILURE") {
              this.dialog_title = "Alert!";
                if (res.data.message)
                    this.dialog_text = res.data.message;
                else
                    this.dialog_text = "Cannot process your request. Please try again later.";
                this.dialog_type = "failure";
                this.dialog = true;
            }
          })
          .catch((error) => {
            window.console.log(error);
          });            

    },
    
    hasSubmitError() {

      //if (this.input.delegate_id.length < 4 || this.input.delegate_auid.length < 4) {
      if (this.input.delegate_auid.length < 4) {
        this.dialog_text = "Delegated Access field is blank. To end delegated access, select 'Do not share' from drop down menu.";
        this.dialog_type = "error";
        this.dialog = true;
        return true; 
      }

      //if (this.input.delegate_id != "stop" || this.input.delegate_auid != "stop") {
      if (this.input.delegate_auid != "stop") {  
        if (this.input.start_date.length <= 0) {
          this.dialog_text = "Start Date cannot be blank";
          this.dialog_type = "error";
          this.dialog = true;
          return true;
        } 

        if ((this.input.indefinite == 0 || this.input.indefinite == "0") && this.input.end_date.length <= 0) {
          this.dialog_text = "End Date cannot be blank";
          this.dialog_type = "error";
          this.dialog = true;
          return true;
        } 

      }

      return false;

    },

    closeDialog() {
      this.dialog = false;
      
      if (this.dialog_type == "success") {
          window.location.reload();
       
      } 
    },    

  },
};
</script>

<style scoped>
h3 {
  font-size: 25px;
  line-height: 1.29167em;
  font-family: "Graphik", Arial, Helvetica, sans-serif;
  font-weight: 500 !important;
  margin: 0 0 0.8em 0;
  color: #4f2c1d !important;
}

.ptoContainer {
  margin-left: -12px !important;
  margin-top: -20px !important;
}

.pto_btn_active {
  background-color: #7a6855 !important;
  color: #ffffff;
}

.italic {
  font-style: italic;
}

.messages /deep/ .v-messages,
.messages /deep/ .v-messages__message {
  font-size: 16px !important;
}

.v-input {
  max-width: 80%;
}

.black--text /deep/ label {
  color: #000000 !important;
  font-weight: 400 !important;
}

.alert {
  color: #e31c3e;
}

.gold {
  border-color: #ffb500;
}

.dt-picker /deep/ .v-btn {
  border-radius: 28px !important;
}


</style>